import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';
import { getIsMESEnabled } from './getIsMESEnabled';

/** Returns true when work order flow is enabled (always true for MES-enabled machines). */
export const getWorkOrderFlowEnabled = createSelector(
  [getCompanySettings, getIsMESEnabled],
  (companySettings, mesEnabled) => {
    if (mesEnabled) return true;
    return companySettings?.workOrderEnabled ?? false;
  }
);
